<template>
  <TWModal
      :title="$t('envelopeShareModal.sharing')"
      :show="show"
      :autoFocus="false"
      :loading="envelopeSharingLoading"
      @close="handleClose"
  >
    <template v-slot:content>
      <EnvelopeSharing
        @sharingUpdated="handleSharingUpdated"
        @interface="handleEnvelopeSharingInterface"
        @isLoading="(value) => { envelopeSharingLoading = value; }"
        :updatingEnvelope="envelope"
      />
    </template>

    <template v-slot:controls>
      <BaseButton
        variant="invisible"
        @click.native="handleClose"
        id="cancel-envelope-share-modal-button"
        data-ec="envelope_share_modal"
        data-et="btn_cancel"
      >
        {{ $t('functional.cancel') }}
      </BaseButton>

      <BaseButton
        @click.native="handleConfirmClicked"
        id="save-envelope-share-modal-button"
        data-ec="envelope_share_modal"
        data-et="btn_confirm"
      >
        {{ $t('functional.confirm') }}
      </BaseButton>
    </template>
  </TWModal>
</template>

<script>
import TWModal from '@/components/tailwind/Modal.vue';
import EnvelopeSharing from '@/components/EnvelopeSharing.vue';
import BaseButton from '@/components/library/buttons/BaseButton.vue';

export default {
  name: 'EnvelopeShareModal',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    envelope: {
      type: Object,
      default: null,
    },
  },
  components: {
    TWModal,
    EnvelopeSharing,
    BaseButton,
  },
  data() {
    return {
      envelopeSharingInterface: null,
      envelopeSharingLoading: false,
    };
  },
  methods: {
    handleEnvelopeSharingInterface(envelopeSharingInterface) {
      this.envelopeSharingInterface = envelopeSharingInterface;
    },
    handleSharingUpdated(data) {
      this.envelope.everyone_permission = data.everyone_permission; // eslint-disable-line vue/no-mutating-props
      this.envelope.sharing = data.actors; // eslint-disable-line vue/no-mutating-props
      this.$bus.$emit('renderGlobalMessage', ({
        message: this.$t('sharing.updateSuccess'),
        icon: 'check',
        type: 'success',
      }));
    },
    handleConfirmClicked() {
      this.envelopeSharingInterface.save().then(() => {
        this.$emit('saved');
      });
    },
    handleClose($event) {
      if ($event && $event.target.classList.contains('multiselect__input')) {
        document.getElementById('save-envelope-share-modal-button').focus();
        return;
      }

      this.resetComponent();
      this.$emit('close');
    },
    resetComponent() {
      Object.assign(this.$data, this.$options.data.apply(this));
    },
  },
};
</script>
